// @flow

//
// IMPORTS
//


// CSS

export const devices = ['mobile', 'tablet', 'desktop'];

const ratioFluidFonts = {
  mobile: 1.25,
  tablet: 1.25,
  desktop: 1.25,
};

// in rem
// const mediumFluidFonts = {
//   mobile: 1.14,
//   tablet: 1.6,
//   desktop: 1.6
// }


// Theme
const theme = {

  ratioFluidFonts: {
    ...ratioFluidFonts,
  },

  unit: 'rem',
  unitSize: 8,
  spacing: 5,
  bgColor: 'darkgray',
  mainColor: 'green',
  stdButton_BgColor: 'red',

  // Top height in pixels
  topHeight: '66px',
  topHeightNum: 66,

  // Footer height in pixels
  footerHeight: '70px',
  footerHeightLength: '70',

  // Default link hover background
  link: {
    hover: {
      backgroundColor: '#cce2ff !important',
      color: 'rgba(0,0,0,.87) !important',
    },
  },

  // Title
  title: {
    fontSize: '20px',
    fontWeight: '400',
  },

  // SubTitle
  subTitle: {
    fontSize: '16px',
    fontWeight: '400',
  },

  // fontWeights.bold
  // Names follow convention from: https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
  fontWeights: {
    thin: '100',
    light: '300',
    normal: '400',
    medium: '500',
    bold: '700',
  },

  // Font Sizes
  /*   font: {
    sizes: {
      mini    : '0.6rem',
      tiny    : '1rem',
      small   : '1.2rem',
      medium  : '1.4rem',
      large   : '1.6rem',
      big     : '1.8rem',
      huge    : '2.0rem',
      massive : '2.2rem',
    },
    fontFamily: '"Quicksand", "sans-serif"'
  }, */

  // STANDARD REBASS VARS
  font: '"Josefin Sans", "sans-serif"',

  breakpoints: [
    // min-width breakpoints in ems
    40, 52, 64,
  ],
  space: [
    0, 6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 84, 90, 96, 102,
  ],
  fontSizes: [
    12, 16, 18, 24, 28, 36, 48,
  ],
  weights: [
    100, 400, 600, 900,
  ],

  colors: {
    black: '#000',
    lightBlack: 'rgb(34,34,34)',
    white: '#fff',
    blue: '#07c',
    lightBlue: '#0077cc',
    orange: '#FCAC68',
    grey: '#666666',
    lightGrey: '#eee',
    grey2: '#efefef',
    grey2_rgb: 'rgb(239,239,239)',
    grey3: '#e6e6e6',
    grey4: '#dddddd',
    greySilver: 'rgb(192,192,192)',
    grey5: 'rgb(176,176,176)',
    grey6: '#efefef',
    lightGrey2: 'rgb(248,248,248)',
    lightGrey3: 'rgb(246,246,246)',
    lightGrey4: 'rgb(240,240,240)',
    purple: '#170e90',
    lightBlack2: '#5c5c5c',
  },

  monospace: '"Roboto Mono", Menlo, monospace',
  radius: 2,

  // THEME VARS BASED UPON THE REBASS ONES

  // Sizes in Rem 10px = 1.0 rem

  // Font sizes (7 levels) for headers in fontsizes for each breakpont
  // First level 1 biggest
  scaleHeaders: [
    [6, 6, 6], // h1
    [5, 5, 5], // h2
    [4, 4, 4], // h3
    [3, 3, 3], // h4
    [2, 2, 2], // h5
    [1, 1, 1], // h6
    [0, 0, 0], // h7
  ],

  // Font sizes (7 levels) for text in fontsizes for each breakpont
  // First level 1 smallest
  scaleTexts: [
    [0, 0, 0],
    [1, 1, 1],
    [2, 2, 2],
    [3, 3, 3],
    [4, 4, 4],
    [5, 5, 5],
    [6, 6, 6],
  ],

  // TODO - Rethink global margins.
  paddingRow: '0px 8rem 0px 8rem',

  paddingRowVal: 8,

  // As reference of names used in Semantic-UI
  // (mini): Dont use this one yet.
  // We use all the others:  tiny(0) small(1) medium(2) large(3) big(4) huge(5) massive(6)

  // Ranges of font sizes generic
  fontRanges: {
    big: [3, 4, 5],
  },

  // Ranges of font sizes specific
  fontsRangespecs: {
    rowSectionMassive: [4, 6],
    rowSectionBig: [3, 4],
    rowSectionHuge: [3, 4],
  },

  // mini tiny small medium large big huge massive

  // fontRangeFluid: {
  //   massive: [
  //     `${mediumFluidFonts.mobile * Math.pow(ratioFluidFonts.mobile, 4)}rem`,
  //     `${mediumFluidFonts.tablet * Math.pow(ratioFluidFonts.tablet, 4)}rem`,
  //     `${mediumFluidFonts.desktop * Math.pow(ratioFluidFonts.desktop, 4)}rem`
  //   ],
  //   huge:  [
  //     `${mediumFluidFonts.mobile * Math.pow(ratioFluidFonts.mobile, 3)}rem`,
  //     `${mediumFluidFonts.tablet * Math.pow(ratioFluidFonts.tablet, 3)}rem`,
  //     `${mediumFluidFonts.desktop * Math.pow(ratioFluidFonts.desktop, 3)}rem`
  //   ],
  //   big:  [
  //     `${mediumFluidFonts.mobile * Math.pow(ratioFluidFonts.mobile, 2)}rem`,
  //     `${mediumFluidFonts.tablet * Math.pow(ratioFluidFonts.tablet, 2)}rem`,
  //     `${mediumFluidFonts.desktop * Math.pow(ratioFluidFonts.desktop, 2)}rem`
  //   ],
  //   large: [
  //     `${mediumFluidFonts.mobile * Math.pow(ratioFluidFonts.mobile, 1)}rem`,
  //     `${mediumFluidFonts.tablet * Math.pow(ratioFluidFonts.tablet, 1)}rem`,
  //     `${mediumFluidFonts.desktop * Math.pow(ratioFluidFonts.desktop, 1)}rem`
  //   ],
  //   medium: [`${mediumFluidFonts.mobile}rem`,
  //           `${mediumFluidFonts.tablet}rem`,
  //           `${mediumFluidFonts.desktop}rem`],
  //   small:  [
  //     `${mediumFluidFonts.mobile * Math.pow(ratioFluidFonts.mobile, -1)}rem`,
  //     `${mediumFluidFonts.tablet * Math.pow(ratioFluidFonts.tablet, -1)}rem`,
  //     `${mediumFluidFonts.desktop * Math.pow(ratioFluidFonts.desktop, -1)}rem`
  //   ],
  //   tiny:  [
  //     `${mediumFluidFonts.mobile * Math.pow(ratioFluidFonts.mobile, -2)}rem`,
  //     `${mediumFluidFonts.tablet * Math.pow(ratioFluidFonts.tablet, -2)}rem`,
  //     `${mediumFluidFonts.desktop * Math.pow(ratioFluidFonts.desktop, -2)}rem`
  //   ],
  //   mini:  [
  //     `${mediumFluidFonts.mobile * Math.pow(ratioFluidFonts.mobile, -3)}rem`,
  //     `${mediumFluidFonts.tablet * Math.pow(ratioFluidFonts.tablet, -3)}rem`,
  //     `${mediumFluidFonts.desktop * Math.pow(ratioFluidFonts.desktop, -3)}rem`
  //   ],
  // },


  fontFactor: {
    massive: ratioFluidFonts.desktop ** 4,
    huge: ratioFluidFonts.desktop ** 3,
    big: ratioFluidFonts.desktop ** 2,
    large: ratioFluidFonts.desktop ** 1,
    medium: ratioFluidFonts.desktop ** 0,
    small: ratioFluidFonts.desktop ** -1,
    tiny: ratioFluidFonts.desktop ** -2,
    mini: ratioFluidFonts.desktop ** -3,
  },

  fontRangeFluid: {
    massive: [
      `${ratioFluidFonts.mobile ** 4}rem`,
      `${ratioFluidFonts.tablet ** 4}rem`,
      `${ratioFluidFonts.desktop ** 4}rem`,
    ],
    huge: [
      `${ratioFluidFonts.mobile ** 3}rem`,
      `${ratioFluidFonts.tablet ** 3}rem`,
      `${ratioFluidFonts.desktop ** 3}rem`,
    ],
    big: [
      `${ratioFluidFonts.mobile ** 2}rem`,
      `${ratioFluidFonts.tablet ** 2}rem`,
      `${ratioFluidFonts.desktop ** 2}rem`,
    ],
    large: [
      `${ratioFluidFonts.mobile ** 1}rem`,
      `${ratioFluidFonts.tablet ** 1}rem`,
      `${ratioFluidFonts.desktop ** 1}rem`,
    ],
    medium: [
      '1rem',
      '1rem',
      '1rem'],
    small: [
      `${ratioFluidFonts.mobile ** -1}rem`,
      `${ratioFluidFonts.tablet ** -1}rem`,
      `${ratioFluidFonts.desktop ** -1}rem`,
    ],
    tiny: [
      `${ratioFluidFonts.mobile ** -2}rem`,
      `${ratioFluidFonts.tablet ** -2}rem`,
      `${ratioFluidFonts.desktop ** -2}rem`,
    ],
    mini: [
      `${ratioFluidFonts.mobile ** -3}rem`,
      `${ratioFluidFonts.tablet ** -3}rem`,
      `${ratioFluidFonts.desktop ** -3}rem`,
    ],
  },

  //
  respPageTopMargin: [3, 5, 5],

  respPagePaddings: ['5%', '5%', '10%'],

  altFont: "'Roboto', sans-serif",

  // Pluging react-typist standard settings
  react_typist_settings: {
    avgTypingDelay: 120,
  },

};

theme.breakpoints = [
  // min-width breakpoints in ems
  40, 52, 64,
];

// name of breakpoints media queries:
theme.namedMediaQueryTable = {
  phablet: `@media (min-width: ${theme.breakpoints[0]}em)`,
  tablet: `@media (min-width:  ${theme.breakpoints[1]}em)`,
  desktop: `@media (min-width: ${theme.breakpoints[2]}em)`,
};

// Globals
const globals = {
  span: {
    color: 'red',
  },
  '@font-face': {
    roboto: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      src: "url('roboto.woff2') format('roboto')",
    },
  },
};


export { theme, globals };



// WEBPACK FOOTER //
// ./src/theme.js